// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"386":"89b2cdb8","425":"00551121"}[chunkId] + ".css";
};